import type { FC, ReactNode } from "react";

import type { CryptoSelectOption } from "../CryptoSelect";
import { useCryptoCombobox } from "./CryptoCombobox.controller";
import { CryptoComboboxPres } from "./CryptoCombobox.pres";

export interface CryptoComboboxProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: CryptoSelectOption[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  emptyMessage?: ReactNode;
  errorMessage?: string;
  required?: boolean;
}

export const CryptoComboboxConnector: FC<CryptoComboboxProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = "Select an option",
  className,
  disabled = false,
  emptyMessage,
  errorMessage,
  required,
}) => {
  const presProps = useCryptoCombobox({
    value,
    onChange,
    options,
    emptyMessage,
  });

  return (
    <CryptoComboboxPres
      {...presProps}
      label={label}
      value={value}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      emptyMessage={emptyMessage}
      errorMessage={errorMessage}
      required={required}
    />
  );
};
